import { render } from "./soldierDetail.vue?vue&type=template&id=66509909&scoped=true"
import script from "./soldierDetail.vue?vue&type=script&lang=js"
export * from "./soldierDetail.vue?vue&type=script&lang=js"

import "./soldierDetail.vue?vue&type=style&index=0&id=66509909&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66509909"]])

export default __exports__